import React, { useEffect, useState } from 'react';
import { scoringApi, ScoreEvidence } from './api';

export default function ScoreEvidenceView({ contentId }: { contentId: string }) {
  const [score, setScore] = useState<ScoreEvidence | null>(null);
  const [error, setError] = useState(false);
  useEffect(() => {
    let active = true;
    setScore(null);
    setError(false);
    scoringApi
      .score(contentId)
      .then(value => {
        if (active) setScore(value);
      })
      .catch(() => {
        if (active) setError(true);
      });
    return () => {
      active = false;
    };
  }, [contentId]);
  return (
    <section aria-label="规则评分">
      <h3>规则评分</h3>
      {error ? (
        <p role="alert">评分明细加载失败，请重新打开详情重试。</p>
      ) : !score ? (
        <p>正在加载评分…</p>
      ) : score.status === 'NOT_APPLICABLE' ? (
        <p>此消息不适用新评分规则，或属于启用前的历史数据。</p>
      ) : score.status === 'PENDING' ? (
        <p>正在评分，所用规则版本：{score.version}</p>
      ) : (
        <>
          <p>
            {score.category === 'NEWS' ? '国内资讯＋港澳台' : '韭研公社'} · 规则版本 {score.version} · 总分{' '}
            {score.total} · {score.status === 'FILTERED' ? '低于展示门槛' : score.featured ? '精选' : '普通展示'}
          </p>
          <table>
            <thead>
              <tr>
                <th>规则项</th>
                <th>命中依据</th>
                <th>计分</th>
              </tr>
            </thead>
            <tbody>
              {score.breakdown?.map(item => (
                <tr key={item.key}>
                  <td>{item.label}</td>
                  <td>{item.matched ? item.matches.join('、') : '未命中'}</td>
                  <td>{item.points}</td>
                </tr>
              ))}
            </tbody>
          </table>
          <details>
            <summary>评分时的数据依据</summary>
            <pre>{JSON.stringify(score.context, null, 2)}</pre>
          </details>
        </>
      )}
    </section>
  );
}
